import { endpointConstants } from "../constants";
import { get, post, put, del } from "../../utils/yodaHttpRequest";

export const yodaStakeholderService = {
  getAll,
  getMe,
  getOrderHistory,
  getOrderHistoryNewCount,
};

function getAll() {
  return get(endpointConstants.YODASTAKEHOLDER.GET_ALL);
}

function getMe() {
  return get(endpointConstants.YODASTAKEHOLDER.GET_ME);
}

function getOrderHistory(pageNumber = 1) {
  const endpoint = endpointConstants.YODASTAKEHOLDER.GET_ORDER_HISTORY;
  return get(endpoint);
}

function getOrderHistoryNewCount() {
  return get(endpointConstants.YODASTAKEHOLDER.GET_ORDER_HISTORY_NEW_COUNT);
}
